import {InjectionToken} from '@angular/core'

/**
 * Main module paths
 */
export const PATH_MAIN = 'main'
export const PATH_CREATE = 'create'
export const PATH_VERIFY = 'verify'
export const PATH_CONFIRMATION = 'confirmation'
export const PATH_SIGN = 'sign'
export const PATH_RESULT = 'result'

/**
 * Extra paths
 */
export const PATH_CONDITIONS = 'conditions'

/**
 * Route param names used in the routing modules
 */
export const ROUTE_PARAM_PROCESS_ID = 'processId'
export const ROUTE_PARAM_EMAIL_HASH = 'emailHash'
export const ROUTE_PARAM_TYPE = 'type'
export const ROUTE_PARAM_EMAIL = 'email'

export interface IEnvironment {
  production: boolean
}
export const ENVIRONMENT =
  new InjectionToken<IEnvironment>('environment')